import { Toolbar } from "@mui/material";
import React, { PropsWithChildren } from "react";
import AnimContainer from "./animation/container";
import NavBar from "./appbar/appbar";
import Footer from "./footer/footer";

const Layout: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div>
      <NavBar />
      <Toolbar />
      {/* @ts-ignore */}
      <AnimContainer>
        <div>{children}</div>
      </AnimContainer>
      <Footer />
    </div>
  );
};

export default Layout;
